import VendorUpdate from '@/models/vendors/VendorUpdate'
import type { TVendorsState } from '@/types/state-types'

export default <TVendorsState>{
  vendorForm: new VendorUpdate(),
  isVendorLoading: false,
  selectedVendor: { ...new VendorUpdate(), isLoading: false },
}
